import { Job } from '../../models/job';
import { JobTypeEnum } from '../../models/jobTypeEnum';
import { PoolerUser } from '../../models/user';
import { getPoolerTransferEligibilityQuery } from './getPoolerTransferEligibilityQuery';

/**
 * Open jobs eligible as transfer targets for a dispo: pooler eligibility rules
 * with `ignorePoolerDepartmentAssignment` so the invitee's customer department
 * assignment does not hide open jobs in the target station; narrows to one
 * customer / department and excludes the source job. Booking still validates in
 * bookInvitee.
 */
export function getOpenJobsForTransferMongoQuery(
  job: Job,
  departmentId: string,
  jobType: JobTypeEnum,
  user: PoolerUser,
): Mongo.Selector<Job> {
  return {
    $and: [
      getPoolerTransferEligibilityQuery(user, {
        ignorePoolerDepartmentAssignment: true,
      }),
      { _id: { $ne: job._id } },
      { date: job.date },
      { 'customer.id': job.customer.id },
      { 'department.id': departmentId },
      { jobType: jobType },
    ],
  };
}
